import { useEffect, useState } from "react";
import CommonUtil from "../../util/CommonUtils";
import {
  REACT_LOCATION,
} from "@/router/ReactEndPoints";
import RightViewLayout from "../../components/RighViewLayout";
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  InputLabel,
  TextField,
} from "@mui/material";
import CustomInput from "../../components/CustomInput";
import { t } from "i18next";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { getAllCities } from "../../services/CityService";
import { createZone } from "../../services/CityZoneService";
import { useTranslation } from "react-i18next";

export default function AddZone() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [payload, setPayload] = useState({
    name: "",
    code: "",
  });

  const [error, setError] = useState({
    name: "",
    code: "",
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });

    setError({
      ...error,
      [name]: "",
      common: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      var request = {
        ...payload,
      };
      createZone(request).then((response) => {
        if (response.data.code === "LVLI0008") {
          enqueueSnackbar(response.data.message, {
            variant: "success",
            anchorOrigin: {
              horizontal: "center",
              vertical: "top",
            },
            style: {
              marginTop: "300px",
            },
          });
          navigate(REACT_LOCATION);
          return;
        }

        switch (response.data.code) {
          case "LVLE0007":
            setError({
              ...error,
              name: response.data.message,
            });
            break;
          case "LVLE0015":
            setError({
              ...error,
              name: response.data.message,
            });
            break;
          case "LVLE0016":
            setError({
              ...error,
              code: response.data.message,
            });
            break;
          case "LVLE0008":
            setError({
              ...error,
              code: response.data.message,
            });
            break;
          case "LVLE0026":
            setError({
              ...error,
              name: response.data.message,
            });
            break;
          case "LVLE0027":
            setError({
              ...error,
              code: response.data.message,
            });
            break;
        }
      });
    }
  };

  const validateForm = () => {
    if (CommonUtil.isEmptyString(payload.name)) {
      setError({
        ...error,
        name: t("LVL0001"),
      });
      return false;
    }
    if (CommonUtil.isEmptyString(payload.code)) {
      setError({
        ...error,
        code: t("LVL0001"),
      });
      return false;
    }
    return true;
  };

  return (
    <RightViewLayout navigateBack={REACT_LOCATION} title={t("LVLLOC0045")}>
      <Grid container spacing={2} px={2}>
        <Grid item md={6} sm={12}>
          <CustomInput
            id={"AddZone-CustomInput-1"}
            required
            error={error.name}
            label={t("LVLLOC0034")}
            size="small"
            name="name"
            value={payload.name}
            inputProps={{
              maxLength: 100,
            }}
            helperText={error.name}
            validation="alpha-numeric"
            handleChange={handleChange}
          />
        </Grid>
        <Grid item md={6} sm={12}>
          <CustomInput
            id={"AddZone-CustomInput-2"}
            required
            error={error.code}
            label={t("LVLLOC0035")}
            size="small"
            name="code"
            value={payload.code}
            inputProps={{
              maxLength: 100,
            }}
            helperText={error.code}
            validation="alpha-numeric"
            handleChange={handleChange}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} px={2}>
        <Grid item sm={12}>
          <Box display={"flex"} flexDirection={"row-reverse"}>
            <Box item pl={2}>
              <Button
                id="AddZone1"
                variant="contained"
                size="large"
                className="text-transform-none"
                onClick={(e) => handleSubmit(e)}
              >
                {t("LVLLOC0036")}
              </Button>
            </Box>
            <Box item>
              <Button
                id="AddZone2"
                className="text-transform-none"
                variant="outlined"
                onClick={() => navigate(REACT_LOCATION)}
                size="large"
              >
                {t("LVLLOC0037")}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </RightViewLayout>
  );
}
